import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MessageBubbleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon>
      <svg
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />{' '}
      </svg>
    </SvgIcon>
  );
};

export default MessageBubbleIcon;
